<template>
  <div>
    <div class="layout-content">
      <div class="left">
        <div class="logo">
          <a class="logo-wrap" href="https://fintechathon.g-ican.com">
            <img
              class="logo-img"
              src="@/assets/transSave/resource/image/5e/ee/5e1be909bac86b0bdde9c0805ce1acee.png"
              alt="深圳大学、微众银行"
            >
          </a>
        </div>
        <ul class="nav">
          <!-- && item.hash === $route.hash -->
          <li
            v-for="(item, index) in navData"
            class="nav-li"
            :class="[
              { active: item.id === $route.meta.id },
              { hoverBox: item.children && item.children.length }
            ]"
            :key="index"
            @click="changeNavTab(item)"
            @mouseenter="mouseenterHandler(item)"
            @mouseleave="mouseleaveHandler(item)"
          >
            <span>{{ item.title }}</span>

            <transition name="gk-slide-in">
              <div v-if="showChildrenMemory[item.id]" class="routerBox">
                <p
                  v-for="(each) in item.children"
                  :key="each.id"
                  @click.stop="changeNavTab(each)"
                >
                  {{ each.title }}
                </p>
              </div>
            </transition>
          </li>
          <!-- <li class="join-btn"><span class="lx"></span><span>立即参赛</span></li> -->
        </ul>
      </div>

      <div class="right">
        <!-- <a :href="bookLink" target="_blank"></a> -->
        <template v-if="isEnLang">
          <div class="button button--international" @click="openRegistration">International Track (Artificial Intelligence) Registration</div>
        </template>
        <template v-else>
          <a class="button" href="https://apply.g-ican.com" target="_blank" rel="noopener">人工智能赛道报名</a>
          <a class="button" href="templates/data-analysis-registration-guide.docx" download>数据分析赛道报名</a>
        </template>
        <div class="lang-switch" aria-label="Language switcher">
          <button :class="{ active: !isEnLang }" @click="$emit('setLang', 'zh-CN')">中</button>
          <span class="line">/</span>
          <button :class="{ active: isEnLang }" @click="$emit('setLang', 'en-US')">EN</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as GlobalLayer from '@/utils/globalLayer'
import internationalRegistrationEn from '@/data/internationalRegistrationEn'

export default {
  props: ['navData', 'index', 'top', 'bookLink'],
  data () {
    return {
      showMobileMenu: false,
      scrollTop: 0,
      ready: false,
      slideActive: Number(this.$route.query.tab),
      activeId: -1,

      showChildrenMemory: {}
    }
  },
  computed: {
    ...mapState(['lang', 'isEnLang']),
    registerImg () {
      return this.isEnLang ? require('../../../assets/img/en/sign_up.png') : require('@/assets/transSave/resource/image/20/73/208abdf91b0ec3a336a1f6c3edd69c73.png')
    }
  },
  created () {
    this.activeId = this.$route.meta.id
  },
  methods: {
    changeNavTab (item) {
      console.log('item', item)
      if(/^https?:\/\//.test(item.name)) {
        window.open(item.name)
        return
      }
      this.$emit('changeNav', item)
    },

    mouseleaveHandler (item) {
      if (item.children && item.children.length) {
        this.$set(this.showChildrenMemory, item.id, false)
      }
    },

    mouseenterHandler (item) {
      if (item.children && item.children.length) {
        this.$set(this.showChildrenMemory, item.id, true)
      }
    },
    openRegistration () {
      GlobalLayer.createModal(this.$store, {
        isSubjectDetail: true,
        subjectDetail: internationalRegistrationEn
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.layout-content {
  display: flex; align-items: center; justify-content: space-between;
  height: 80px;

  .left {
    display: flex; align-items: center;
  }

  .right {
    display: flex; align-items: center; gap: 20px;
  }

  .lang-switch {
    display: flex;
    align-items: center;
    gap: 5px;
    flex: none;
    margin-left: 2px;
    padding-left: 14px;
    border-left: 1px solid #e2e5e9;
    color: #9aa0aa;

    button {
      padding: 6px 2px;
      border: 0;
      color: inherit;
      font-size: 12px;
      background: transparent;
      cursor: pointer;

      &.active {
        color: #d83a40;
        font-weight: 600;
      }
    }

    .line {
      color: #d5d8dd;
      font-size: 11px;
    }
  }

  .logo {
    width: 412px;
    margin-right: 24px;

    .logo-wrap {
      display: flex; align-items: center; gap: 18px;
    }

    .logo-img {
      flex: 0 0 auto;
      width: 300px; height: 32px;
    }

    .logo-img-ican {
      flex: 0 0 auto;
      width: 94px;
      height: auto;
      max-height: 32px;
      object-fit: contain;
    }
  }

  .nav {
    display: flex; align-items: center;
    flex: 0 0 auto;
    font-size: 17px;
    // color: #fff;
    // margin-left: 32px;
    font-weight: 400;

    .nav-li {
      position: relative;
      display: flex; align-items: center;
      flex: 0 0 auto;
      height: 80px;
      padding: 12px 0;
      margin-right: 42px;
      line-height: 1;
      white-space: nowrap;
      @extend %transition;

      &:last-child {
        margin-right: 0;
      }

      & span:hover {
        color: #000000;
        font-weight: 600;
        cursor: pointer;

        @include enlayoutInner {
          font-weight: 400;
        }
      }

      &.active {
        color: #000000;
        font-weight: 600;

        &::after {
          content: "";
          position: absolute; top: 60px; left: 50%;
          width: 30px; height: 5px;
          background: #DE3640;
          transform: translateX(-50%);
        }

        @include enlayoutInner {
          font-weight: 400;
        }
      }
    }
  }

  .lang {
    margin-right: 50px;
    font-size: 18px;
    color: #FFF;

    & span {
      cursor: pointer;
    }

    & .line {
      margin: 0 10px;
    }
  }

  .active {
    color: #FF0054;
  }

  .button {
    width: 130px; height: 48px;
    line-height: 1.2;
    text-align: center;
    background: #DA3A3E;
    cursor: pointer;
    font-size: 14px;
    color: #FFFFFF;
    // background: linear-gradient(-30deg,rgba(255,0,84,1),rgba(43,112,251,1));
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    &--international {
      width: 280px;
      min-width: 280px;
      flex: 0 0 280px;
      padding: 0 14px;
      font-size: 12px;
      line-height: 1.2;
      white-space: normal;
    }
    &:hover {
      background: #CB232D;
    }
    img {
      position: absolute; z-index: 1;
      width: 100%;
    }
    .hover {
      // position: absolute; top: 20px; left: 20px; right: 20px; bottom: 20px;
      // @extend %transition;
      transition: all linear 0.3s;
    }
  }
}

.hoverBox {
  position: relative;

  & .routerBox {
    position: absolute; top: calc(100% + 0px); left: 50%; z-index: 1;
    min-width: 150px;
    margin-left: -75px; padding: 12px 0;
    text-align: center;
    border: 1px solid #D8D8D8;
    background: rgba(#fff, 1);
    box-shadow: 0px 3px 24px 0px rgba(0,0,0,0.0600);
    font-size: 14px;
    color: #818B91;

    & p {
      height: 54px;
      margin: 0 12px;
      font-size: 16px; font-weight: 400;
      color: #000000;
      line-height: 54px;
      cursor: pointer;

      &:hover {
        background: #F3F7FB;
      }
    }
  }

  &:last-child {
    .routerBox {
      min-width: 230px;
      margin-left: -110px;
    }
  }
}

</style>
